import { useEffect } from "react";

/** Sets the tab title + description while a page is mounted (for people browsing).
 *  Facebook reads the static tags in public/index.html instead — see scripts/og-pages.mjs. */
export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    if (description) document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  }, [title, description]);
}
